import { AccountMetricsResponse } from '@/types/composer-dashboard';
import { apiRequest } from '@/utils/api-request';

export async function getAccountMetrics(
  orgId: string,
): Promise<AccountMetricsResponse> {
  const response = await apiRequest<AccountMetricsResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/accounts`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch account metrics');
  }

  return response.data;
}
